export default __webpack_public_path__ + "static/media/logo-staging.1bb61b64.png";